import { Injectable } from '@angular/core';
import { UrlTree } from '@angular/router';
import { first, Observable, skipWhile } from 'rxjs';
import { NzModalService } from 'ng-zorro-antd/modal';
import { EndTrialPeriodComponent } from '../../features/dialogs/end-trial-period/end-trial-period.component';
import { DomainsService } from '../services/domains.service';
import { SoftwareTrialStatus } from '../interfaces/software-interface';
import { map } from 'rxjs/operators';
import { DomainInterface, DomainProductDto } from '@shared/interfaces/domain-interface';

@Injectable({
  providedIn: 'root',
})
export class EndTrialPeriodGuard {
  public constructor(
    private readonly modalService: NzModalService,
    private readonly domainService: DomainsService,
  ) {}

  public canActivate(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    this.domainService.currentDomain$
      .pipe(
        skipWhile((d) => !d),
        first(),
        map((domain: DomainInterface | null) => {
          if (domain?.domainProduct?.some((item: DomainProductDto) => item.stateTrial === SoftwareTrialStatus.Buyed)) {
            return !domain?.domainProduct?.some(
              (item: DomainProductDto) => item.stateTrial == SoftwareTrialStatus.Buyed,
            );
          }
          return (
            domain?.domainProduct
              ?.map((item: DomainProductDto) => item.stateTrial)
              .includes(SoftwareTrialStatus.Expired) ?? false
          );
        }),
      )
      .subscribe((isExpired: boolean) => {
        if (isExpired) {
          this.modalService.create<EndTrialPeriodComponent>({
            nzWidth: '100%',
            nzContent: EndTrialPeriodComponent,
            nzFooter: [],
          });
        }
      });
    return true;
  }
}
